var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examplesModal"},[_c('i',{staticClass:"el-icon-close",on:{"click":function($event){return _vm.$emit('hidden')}}}),_c('div',{staticClass:"examplesContant"},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }